<template>
  <fragment>
    <div class="form-checkbox" :class="{ 'form-checkbox__disabled': disable }">
      <label class="form-checkbox__container">
        {{ label }}
        <input v-model="value" :checked="value" type="checkbox" />
        <span class="form-checkbox__checkmark"></span>
      </label>
    </div>

    <template v-if="twoLevel">
      <template v-for="(element, index) in twoLevel[value]">
        <div :key="index">
          <form-multi-select
            v-if="element.elementType === 'FormMultiSelect'"
            :input-model="element.multiOptions"
            :value="element.value"
            :fieldname="element.fieldname"
            :label="element.label"
            :error="element.error"
            :keymonitor="keymonitor"
            :disabled="disable"
            @update="twoLevelUpdate"
          />
        </div>
      </template>
    </template>
  </fragment>
</template>

<script>
import FormMultiSelect from "./FormMultiSelect";

export default {
  name: "FormCheckbox",
  components: { FormMultiSelect },
  props: {
    error: {
      type: Boolean,
      default: false
    },
    serverError: {
      type: Boolean,
      default: false
    },
    valueModal: {
      type: Boolean,
      default: false
    },
    twoLevel: {
      type: [Boolean, Object],
      default: false
    },
    fieldname: {
      type: String,
      default: ""
    },
    twoLevelUpdate: {
      type: Function,
      default: () => {}
    },
    keymonitor: {
      type: Function,
      default: () => {}
    },
    update: {
      type: Function,
      default: () => {}
    },
    label: {
      type: String,
      default: ""
    },
    errorLabel: {
      type: String,
      default: ""
    },
    bottomInfo: {
      type: String,
      default: ""
    },
    inputOptions: {
      type: Array,
      default: () => []
    },
    disable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    value: {
      get() {
        return this.valueModal;
      },
      set(newValue) {
        this.$emit("update", {
          value: newValue,
          fieldname: this.fieldname
        });
      }
    }
  }
};
</script>
